import { Outlet, Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/perms";

export const IfCan = ({ module, level, children }) => {
  const { user } = useAuth();
  return can(user, module, level) ? children : null;
};

export default function PermGate({ module, level = "view", label }) {
  const { user } = useAuth();
  if (can(user, module, level)) return <Outlet />;
  return (
    <div className="max-w-md mx-auto mt-16 text-center" data-testid="no-access">
      <ShieldOff className="w-10 h-10 text-slate-300 mx-auto" />
      <h1 className="mt-3 font-heading text-xl font-semibold text-slate-900">No access to {label}</h1>
      <p className="text-sm text-slate-500 mt-1">Your role doesn't include {label}. Ask an Admin to change your role's permissions.</p>
      <Link to="/dashboard" className="inline-block mt-4 text-sm text-indigo-600 hover:underline">Back to dashboard</Link>
    </div>
  );
}
